import { LogsList } from 'components'
import { Base } from 'layouts'
export function Logs() {
  return (
    <Base>
      <LogsList />
    </Base>
  )
}
